import { css } from "emotion";
import Image from "../Image";
import ContentBlock from "./ContentBlock";
import H2 from "../global/H2";

const wrapper = css({
  display: "flex",
  justifyContent: "space-between",
  padding: "0 80px",
  alignItems: "center",
  "@media(max-width:800px)": {
    display: "block",
    padding: 0
  }
});

const imageWrapper = css({
  maxWidth: 495,
  maHeight: 339
});

const headingWrapper = css({
  textAlign: "center"
});

const SplitContent = ({
  image,
  imageSrcSet,
  alt,
  bgColor,
  children,
  title,
  right = true
}) => {
  const textWrapperProps = {
    maxWidth: 480,
    h3: {
      marginBottom: 16
    },
    p: {
      marginBottom: 24
    },
    "@media(max-width:800px)": {
      margin: "0 auto",
      marginBottom: 0
    }
  };
  textWrapperProps[`margin${right ? "Right" : "Left"}`] = "40px";
  const textWrapper = css(textWrapperProps);
  return (
    <ContentBlock color={bgColor}>
      <div className={headingWrapper}>
        {title ? (
          <H2 marginBottom={72} marginBottomMobile={24}>
            {title}
          </H2>
        ) : null}
      </div>
      <div className={wrapper}>
        {!right ? (
          <div className={imageWrapper}>
            <Image imageURL={image} srcSet={imageSrcSet} alt={alt} />
          </div>
        ) : null}
        <div className={textWrapper}>{children}</div>
        {right ? (
          <div className={imageWrapper}>
            <Image imageURL={image} srcSet={imageSrcSet} alt={alt} />
          </div>
        ) : null}
      </div>
    </ContentBlock>
  );
};

export default SplitContent;
